import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView } from "../lib/analytics";

// Initializes GA4 once and tracks each route change as a page_view.
// Excludes /admin/* (handled inside trackPageView).
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    // Defer a tick so document.title is up-to-date after the route renders
    const id = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 0);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
